/**
 * Mise en forme des noms de personnes.
 *
 * La règle du comité : nom de famille en capitales, prénom avec une seule
 * majuscule initiale. Le serveur l'applique de toute façon à l'enregistrement ;
 * la refaire ici sert à ce que le visiteur voie tout de suite ce qui sera
 * gardé, au lieu de le découvrir sur sa confirmation.
 */

/** Espaces resserrés, sans rogner celui qu'on est en train de taper. */
function nettoyer(valeur: string): string {
  return valeur.replace(/\s{2,}/g, ' ').replace(/^\s+/, '');
}

/** Nom de famille : capitales. */
export function nomFamille(valeur: string): string {
  return nettoyer(valeur).toUpperCase();
}

/**
 * Prénom : une majuscule par élément, le reste en minuscules.
 *
 * Les composés gardent leur structure — « jean-PIERRE » devient
 * « Jean-Pierre ». Le découpage porte sur l'espace, le trait d'union et
 * l'apostrophe, seuls séparateurs qui ouvrent un nouvel élément.
 */
export function prenomUsage(valeur: string): string {
  return nettoyer(valeur)
    .toLowerCase()
    .replace(/(^|[\s\-'’])([^\s\-'’])/g, (_, separateur: string, lettre: string) =>
      separateur + lettre.toUpperCase()
    );
}
